import React, { useEffect, useState, useSelector } from "react";
import TrackLimoLogo from "../../assets/tracklimo-logo.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Bg from "../../assets/bg.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/fontawesome-free-solid";
import Footer from "../../components/footer/Footer";
// import Footer from "../../components/footer/Footer";

const ResetPassword = () => {
  const navigate = useNavigate();

  // selectors
  const [errorMessage, setErrorMessage] = useState("");

  // states
  const [loginInputField, setloginInputField] = useState({
    username: "",
  });

  const { token } = useParams();
  const [tokenvalidmsg, settokenvalidmsg] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpasswrod, setconfirmpassword] = useState();
  const [tokenStatus, setTokenStatus] = useState();
  // const [errMSg, seterrMSg] = useState("");
  const [successMsg, setsuccessMsg] = useState("");
  const [loading, setloading] = useState(false);
  // const [showPassword1, setShowPassword1] = useState(false);
  // const [showPassword2, setShowPassword2] = useState(false);
  const [checkpassword, setCheckPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  console.log("tokenStatus=======>", tokenStatus);
  // console.log("checkpassword===>",checkpassword);
  // console.log(errMSg,"<---error msg ");

  // console.log(password);
  // console.log(confirmpasswrod,"<---confirmpasswrod");

  const checkTokenValidOrNot = async () => {
    console.log("Function called");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/affiliates/checkToken?token=${token}`
      );

      console.log("response=======>", res);
      return res;
    } catch (error) {
      console.log("Error=======>", error.response);
      return error.response;
    }
  };

  useEffect(() => {
    if (token) {
      const tokenStatusWrapper = async () => {
        let checkTokenStatus = await checkTokenValidOrNot();
        if (checkTokenStatus?.status === 400) {
          toast.warning("Token Expired");
          navigate("/forgotpassword");
          return;
        }
      };
      tokenStatusWrapper();
    }
  }, []);

  useEffect(() => {
    if (password !== confirmpasswrod) {
      setCheckPassword(false);
    } else {
      setCheckPassword(true);
    }
  }, [confirmpasswrod, password]);

  const resetPassword = async () => {
    if (!password) {
      return toast.warning("Please enter password");
    }
    if (!confirmpasswrod) {
      return toast.warning("Please enter confirmpasswrod");
    }
    if (password !== confirmpasswrod) {
      // seterrMSg("Password and Confirm password does not match")
      toast.warning("Password and Confirm password does not match");
    } else {
      // seterrMSg("");
      setloading(true);
      const response = await axios.post(
        ` ${process.env.REACT_APP_BASE_URL}/affiliates/resetPassword?token=${token}`,
        {
          password,
        }
      );
      console.log(response, "Response from Reset Password");
      if (response?.status === 200) {
        setloading(false);
        setsuccessMsg(response.data.message);
        toast.success(response.data.message);
        navigate("/login");
        return;
      } else {
        setloading(false);
        // seterrMSg(response.data.message);
        toast.error(response.data.message);
      }
    }
  };

  return (
    <div className="relative">
      <div className="h-screen w-screen absolute">
        <div className="bg-black opacity-90 absolute w-full h-full"></div>
        <img src={Bg} alt="" className="h-full w-full object-cover" />
      </div>

      <div className="space-y-5 sm:space-y-10 relative px-2">
        <Link to="/">
          <div className="flex space-x-2 justify-start mx-5 xs:mx-5 sm:mx-16 md:mx-32">
            <img
              src={TrackLimoLogo}
              alt="Tracklimo Logo"
              className="w-48 h-32 sm:w-52 sm:h-24 md:w-60 md:h-32"
            />
          </div>
        </Link>

        <div className="mt-6 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
          <Link to="/login" className="bg-slate-900 border border-slate-800 rounded-full p-2">
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
            />
          </Link>
        </div>

        <div className="flex justify-center mx-5 sm:mx-0 md:mx-40">
          <div className="relative">
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#190061] to-[#0A1B30] absolute -top-10 sm:-top-20 -left-20 md:-top-14 md:-left-32 lg:-left-16 xl:-left-32"></div>
            {/* <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#041248] to-[#0A1B30] absolute -right-6 -bottom-10 sm:-bottom-16 sm:right-10 md:-bottom-12 md:-right-16 lg:-right-6 lg:-bottom-6 xl:-right-16 xl:-bottom-12"></div> */}
          </div>
          <div className="backdrop-blur-md bg-slate-800/5 border border-white/30 w-full sm:w-4/5 md:w-full lg:w-[420px] xl:w-[480px] 2xl:w-[480px] rounded-2xl py-10 shadow-[rgba(0,0,15,0.5)_0px_5px_4px_10px]">
            <div className="text-3xl sm:text-4xl px-6 sm:px-10 text-left text-gray-200 font-semibold">
              Reset your password
            </div>

            <div className="px-6 sm:px-10 pt-6 space-y-3.5">
              <div className="relative">
                <InputField
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  onChange={(e) => {
                    setpassword(e.target.value);
                  }}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="absolute top-5 right-3 transform -translate-y-1/2 cursor-pointer text-gray-500"
                  onClick={togglePasswordVisibility}
                />
              </div>
              <div className="relative">
                <InputField
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Enter confirm password"
                  onChange={(e) => {
                    setconfirmpassword(e.target.value);
                  }}
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEye : faEyeSlash}
                  className="absolute top-5 right-3 transform -translate-y-1/2 cursor-pointer text-gray-500"
                  onClick={toggleConfirmPasswordVisibility}
                />
              </div>
              {/* <div className="space-y-2">
              {!errorMessage && (
                <p className="error"> {errorMessage} </p>
              )}
                {!isLoggedin ? (
                  <div
                    onClick={()=>{
                      resetPassword();
                    }}
                    className="w-full flex justify-center  cursor-pointer bg-gradient-to-b py-1  from-teal-600 to-teal-800 hover:bg-gradient-to-t text-lg font-medium rounded-md text-white"
                  >
                    Submit
                  </div>
                ) : (
                  <div className="w-full flex justify-center  cursor-pointer bg-gradient-to-b py-1  from-teal-600 to-teal-800 hover:bg-gradient-to-t text-lg font-medium rounded-md text-white">
                    <div class="flex items-center justify-center">
                      <div
                        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      >
                        <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                          Loading...
                        </span>
                      </div>
                    </div>
                  </div>
                )}                
              </div> */}
              <div
                onClick={checkpassword === true ? resetPassword : undefined}
                className={`w-full flex justify-center cursor-pointer ${
                  checkpassword
                    ? "bg-gradient-to-r py-2.5  from-[#2f4def] to-[#0110a6]"
                    : "bg-gradient-to-r py-2.5  from-[#adb9fa] to-[#7882f3] cursor-not-allowed"
                }  text-2xl font-medium rounded-md text-white`}
              >
                Submit
              </div>
            </div>
            {/* <div className="px-10"><Footer /></div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

const InputField = ({ label, type, onChange, placeholder }) => {
  return (
    <>
      <div className="space-y-0.25">
        <div className="text-lg text-gray-200 font-semibold ">{label}</div>
        <input
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          className="bg-transparent border rounded-md w-full px-2 py-2.5 target:bg-transparent focus:outline-none focus:border-blue-600 text-gray-400 text-sm font-normal"
        />
      </div>
    </>
  );
};
